// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItemComment from "app/models/TimelineItemComment";

import "./TimelineConversation.scss";
import TimelineCardComment from "app/components/TimelineCardComment/TimelineCardComment";
import TimelineCardSendComment from "app/components/TimelineCardSendComment/TimelineCardSendComment";
import User from "app/models/User";

type Props = {
    userId: ?number,
    user: ?User,
    comments: TimelineItemComment[],
    onDelete: Function,
    onComment: Function,
    serverTime: any
};

@observer
export default class TimelineConversation extends React.Component<Props> {
    handleDelete(comment: TimelineItemComment) {
        this.props.onDelete(comment);
    }

    render() {
        let placeholder =
            this.props.comments.length > 0
                ? "Join the conversation"
                : "Start a conversation";

        return (
            <div className="TimelineConversation">
                <div className="TimelineConversation__comments">
                    {this.renderComments()}
                </div>

                <TimelineCardSendComment
                    onComment={this.props.onComment}
                    user={this.props.user}
                    placeholder={placeholder}
                />
            </div>
        );
    }

    renderComments() {
        const comments = this.props.comments;
        if (!comments.length) {
            return null;
        }

        const userId = this.props.userId;

        return comments.reverse().map(comment => {
            const deletable: boolean = !!userId && comment.author_id === userId;

            return (
                <TimelineCardComment
                    key={comment.key}
                    comment={comment}
                    onDelete={this.handleDelete.bind(this, comment)}
                    deletable={deletable}
                    serverTime={this.props.serverTime}
                />
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineConversation/TimelineConversation.js